<template>
    <div class="chart-container">
        <canvas ref="chartCanvas"></canvas>
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    onBeforeUnmount,
    watch,
} from 'vue';

import {
    Chart,
    registerables,
} from 'chart.js';

Chart.register(...registerables);

const valueLabelsPlugin = {
    id: 'valueLabels',

    afterDatasetsDraw(chart) {
        const { ctx } = chart;
        const dataset = chart.data.datasets[0];
        const meta = chart.getDatasetMeta(0);

        ctx.save();
        ctx.fillStyle = '#25413e';
        ctx.font = 'bold 12px sans-serif';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';

        meta.data.forEach((bar, index) => {
            const value = dataset.data[index];

            ctx.fillText(
                Funcoes.formatInteger(value),
                bar.x + 7,
                bar.y
            );
        });

        ctx.restore();
    },
};

// Caso não queira importar Funcoes somente para isso,
// pode trocar Funcoes.formatInteger(value) por String(value).
import { Funcoes } from '@/funcoes/utils';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },

    setup(props) {
        const chartCanvas = ref(null);
        let chartInstance = null;

        const createChart = () => {
            if (chartInstance) {
                chartInstance.destroy();
                chartInstance = null;
            }

            if (!props.data?.length || !chartCanvas.value) {
                return;
            }

            const maiorValor = Math.max(
                ...props.data.map(item => Number(item.y) || 0)
            );

            chartInstance = new Chart(chartCanvas.value, {
                type: 'bar',

                data: {
                    labels: props.data.map(item => item.x),

                    datasets: [{
                        data: props.data.map(item => item.y),

                        backgroundColor: '#cfe8e8',
                        borderColor: '#5c7f7f',
                        borderWidth: 1,

                        borderRadius: 5,
                        borderSkipped: false,

                        barThickness: 30,
                        maxBarThickness: 34,

                        // Permite desenhar o número após a barra.
                        clip: false,
                    }],
                },

                plugins: [valueLabelsPlugin],

                options: {
                    indexAxis: 'y',
                    responsive: true,
                    maintainAspectRatio: false,

                    animation: {
                        duration: 500,
                    },

                    layout: {
                        padding: {
                            top: 4,
                            right: 35,
                            bottom: 4,
                            left: 0,
                        },
                    },

                    plugins: {
                        legend: {
                            display: false,
                        },

                        tooltip: {
                            displayColors: false,

                            callbacks: {
                                label(context) {
                                    const value = context.parsed.x;

                                    return `${Funcoes.formatInteger(value)} alertas`;
                                },
                            },
                        },
                    },

                    scales: {
                        x: {
                            beginAtZero: true,
                            suggestedMax: Math.ceil(maiorValor * 1.12),

                            border: {
                                display: false,
                            },

                            grid: {
                                color: '#e7eeee',
                            },

                            ticks: {
                                precision: 0,
                                color: '#657979',
                            },

                            title: {
                                display: false,
                            },
                        },

                        y: {
                            border: {
                                display: false,
                            },

                            grid: {
                                display: false,
                            },

                            ticks: {
                                color: '#4c5f5f',
                                font: {
                                    size: 12,
                                },
                            },

                            title: {
                                display: false,
                            },
                        },
                    },
                },
            });
        };

        onMounted(createChart);

        watch(
            () => props.data,
            createChart,
            { deep: true }
        );

        onBeforeUnmount(() => {
            chartInstance?.destroy();
        });

        return {
            chartCanvas,
        };
    },
};
</script>

<style scoped>
.chart-container {
    width: 100%;
    height: 260px;
    margin: 0 auto;
}

canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>